import { useEffect, useState } from 'react';
import { useAppointmentDetailsContext } from '../contexts/appointmentdetails.context';
import { APIUtils } from '../../../../utils/apiutils';
import httpClient from '../../../../services/http';
import Swal from 'sweetalert2';
import { generateRandomString } from '../../../../utils/utils';
import { CUSTOM_EVENTS } from '../../../../utils/constants';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

const useFetchChats = () => {
    dayjs.extend(utc);
    const { appointmentDetails } = useAppointmentDetailsContext();
    const [chats, setChats] = useState([]);

    // Scroll only when new messages arrive
    useEffect(() => {
        document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.SCROLL_CHAT_WINDOW));
    }, [chats.length]);

    const apptId = appointmentDetails && appointmentDetails.id;
    const apptDateTime = appointmentDetails && appointmentDetails.apptdatetime;
    useEffect(() => {
        const addTempChatUI = (e) => {
            const chat = e.detail;
            setChats(prev => [...prev, {...chat, id: generateRandomString(3)}]);
        };

        if (!apptId || !apptDateTime) return;

        const isChatAllowed = () => {
            const apptDate = dayjs(apptDateTime);
            const differenceInHours = apptDate.diff(dayjs.utc(new Date()), 'hour'); // apptDate - now
            if (differenceInHours < 0) {
                return false;
            }
            if (differenceInHours > 72) {
                return false;
            }

            return true;
        };

        const getAppointmentChat = async () => {
            try {
                const url = `${APIUtils.getAPIEndpoint('myappointment-get-chat')}/${apptId}`;
                const res = await httpClient.get(url).then(res => res.data);
                if (res.status === 'success') {
                    setChats(res.data);
                }
                // else {
                //     setDepartments([]);
                // }
            } catch (error) {
                console.error('Error fetching appointment chats:', error);
                if (error?.cause?.response?.data?.message) {
                    Swal.fire('Sorry!', error.cause.response.data.message, 'error');
                    // setLoading(false);
                    return;
                }
                Swal.fire('Something Went Wrong!', '', 'error');
            }
        };

        getAppointmentChat();
        // NOTE: Increase the time when deployed
        const timer = setInterval(() => {
            if (!isChatAllowed()) {
                clearInterval(timer);
                return;
            }
            getAppointmentChat();
        }, 1000);

        document.addEventListener(CUSTOM_EVENTS.ADD_TEMP_CHAT_MSG, addTempChatUI);
        return () => {
            clearInterval(timer);
            document.removeEventListener(CUSTOM_EVENTS.ADD_TEMP_CHAT_MSG, addTempChatUI);
        };
    }, [apptId, apptDateTime]);

    return {
        chats
    };
};

export default useFetchChats;